module.exports = __webpack_public_path__ + "static/media/tresio.8fe47533.svg";